// extracted by mini-css-extract-plugin
module.exports = {"root":"Drawer_root_tkCRZ","hidden":"Drawer_hidden_qQurn","overlay":"Drawer_overlay_GZFKX","shown":"Drawer_shown_2MNO8","container":"Drawer_container_1z-UO"};